import { avaatUudenSivunLyrics, keskenerasiiTaideteoksiiLyrics, saAnnatMulleKaikenLyrics } from "../assets/lyrics";
import SongBlock from "../components/SongBlock/SongBlock";

const MusicPage = () => {
  return (
    <div className="MusicPage pb-24">
      <div
        className="flex p-2 m-auto text-left max-w-screen-2xl flex-col md:flex-row justify-center"
      >
        <div className="flex-1 max-w-xl min-w-xl">
          <div className="p-2 md:p-8">
            <h2 className="text-4xl font-bold">Musiikki</h2>
            <div className="border-t border-gray-300 border-solid">
            <SongBlock
              lyrics={avaatUudenSivunLyrics}
              title="1. Avaat Uuden Sivun"
            />
            <SongBlock
              lyrics={saAnnatMulleKaikenLyrics}
              title="2. Sä annat mulle kaiken"
            />
            <SongBlock
              lyrics={keskenerasiiTaideteoksiiLyrics}
              title="3. Keskeneräsii Taideteoksii"
            />
            </div>
          </div>
        </div>
        <div className="text-center block lg:-mt-20 relative">
          <iframe
            className="shadow-2xl bg-gray-900"
            title="Spotify"
            src="https://open.spotify.com/embed/artist/1gksgycDNzFiSND7NG58Vx"
            width="360"
            height="456"
            frameBorder="0"
            allow="encrypted-media"
          />
        </div>
      </div>
    </div>
  );
};

export default MusicPage;